import { SVGAttributes } from 'react'

const CheckmarkCircleIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10ZM9.04436 15.0338L16.5889 7.77125C16.6926 7.67739 16.6926 7.50727 16.5889 7.41341L14.9592 5.79954C14.8617 5.70568 14.6848 5.70568 14.5872 5.79954L8.85529 11.2976L6.19534 8.82447C6.09776 8.73061 5.92089 8.73061 5.8233 8.82447L4.24441 10.417C4.14073 10.5108 4.14073 10.6809 4.24441 10.7748L8.66622 15.0338C8.72721 15.0748 8.7821 15.1041 8.85529 15.1041C8.92848 15.1041 8.98337 15.0748 9.04436 15.0338Z"
        />
    </svg>
)
export default CheckmarkCircleIcon
